import countingDevicesReducer from "./reducers";

export default countingDevicesReducer;